import { useState } from "react";
import { useCart } from "../../../../../hooks/useCart";
import { useGetTransactions } from "../../../../../hooks/api/queries/useTransactions";
import { useGetSellmodeAssignedTerminal } from "../../../../../hooks/useGetSellmodeAssignedTerminal";

export const useTransferListener = ({ paymentProvider }) => {
  const { isCreatingOrder, submitOrder } = useCart({});
  const { assignTerminalProviders } = useGetSellmodeAssignedTerminal({});
  const terminalDetails = assignTerminalProviders?.[paymentProvider];
  const [selectedTnx, setSelectedTnx] = useState(null);

  const { data, isLoading } = useGetTransactions({
    queries: `?per_page=10&page=1&payment_method=offline_transfer&terminal_id=${terminalDetails?.terminal_id}&unlinked=true&is_static_account=true`,
    isEnabled: terminalDetails?.terminal_id ? true : false,
  });

  const handleLinkTransaction = (tnx_id) => {
    submitOrder({
      paymentProps: {
        transaction_id: tnx_id,
      },
    });
  };

  return {
    terminalDetails,
    isLoading,
    transactions: data?.data,
    selectedTnx,
    isCreatingOrder,
    setSelectedTnx,
    handleLinkTransaction,
  };
};
